import { format, isAfter, startOfDay } from "date-fns";

export const formatDateRange = (range: { from?: Date; to?: Date }) => {
  const { from: fromDate, to: toDate } = range;

  if (fromDate && toDate) {
    const sameYear = fromDate.getFullYear() === toDate.getFullYear();

    const startFormatted = sameYear
      ? format(fromDate, "MMM d")
      : format(fromDate, "MMM d, yyyy");

    const endFormatted = format(toDate, "MMM d, yyyy");

    return `${startFormatted} - ${endFormatted}`;
  }

  const single = fromDate ?? toDate;
  return single ? format(single, "MMM d, yyyy") : "Custom";
};

export const applyFromDate = (
  range: { from?: Date; to?: Date } | undefined,
  from: Date,
) => ({
  from,
  to: range?.to && !isAfter(from, range.to) ? range.to : startOfDay(new Date()),
});
